@if (data && (data.type === 'sms' || data.type === 'mail')) {
  <mat-chip-listbox>
    @for (item of data.dataForShow; track item) {
      <mat-chip-option>{{item}}</mat-chip-option>
    }
  </mat-chip-listbox>
}
@if (data && data.type === 'serial') {
  <mat-chip-listbox>
    @for (item of data.dataForShow; track item) {
      <mat-chip-option>{{item.firstName + ' ' + item.lastName }}</mat-chip-option>
    }
  </mat-chip-listbox>
}
